// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const masterTcService = {};

masterTcService.getMaterTcList = function () {
  return lossClient({
    url: "/reference/MasterTc",
    method: "get",
  });
};

export default masterTcService;
